export default __webpack_public_path__ + "static/logo-0eeabb292c04f0f886865536dfbd1d75.jpg";